<template>
    <v-container class="pa-5 d-flex flex-column" fluid style="height: 100%">
        <page-title>
            Zamówienia nadane w czasie - realizacja na tydzień
        </page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="end" dense>
            <v-col cols="12" md="4" lg="2">
                <v-menu
                    v-model="menuFrom"
                    :loading="actionLoading.getWeeklySentOrders"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template #activator="{on}">
                        <v-text-field
                            :value="dateRangeText"
                            label="Data"
                            prepend-icon="mdi-calendar"
                            readonly
                            solo
                            hide-details
                            append-icon
                            class="mt-0"
                            v-on="on"
                        />
                    </template>
                    <v-date-picker
                        v-model="date"
                        range
                        no-title
                        first-day-of-week="1"
                        @input="setRange($event)"
                    />
                </v-menu>
            </v-col>
        </v-row>

        <v-row justify="end">
            <v-col cols="auto">
                <v-btn
                    text
                    small
                    data-sentry-label="Generuj raport"
                    :loading="actionLoading.generateReport"
                    @click="generateReport"
                >
                    <v-icon small left color="red">
                        mdi-file-pdf
                    </v-icon>
                    Generuj raport
                </v-btn>
            </v-col>
        </v-row>
        <v-card
            width="100%"
            height="100%"
            class="d-flex flex-column"
            :loading="actionLoading.getWeeklySentOrders"
        >
            <v-card-text style="height: 99.9%; width: 100%; position: relative">
                <canvas ref="chartContainer" />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'

import filters from '@/mixins/dataTableFilters'
import dateFormatter from '@/mixins/dateFormatter'

import { errorHandler } from '@/utils/errorHandler'
import './../../../../public/fonts/roboto/Roboto-Light.js'

import { Chart, BarController, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { jsPDF } from 'jspdf'
import { format, getDaysInMonth, startOfWeek, endOfWeek } from 'date-fns'
import html2canvas from 'html2canvas'

export default {
    name: 'WeeklySentOrders',
    components: {
        PageTitle
    },
    mixins: [filters, dateFormatter],
    beforeRouteLeave(to, from, next) {
        if (!this.filtersCleared) {
            this.$store.dispatch('reportsAndAnalysis/orders/clearWeeklySentOrdersFilters')
        }
        next()
    },
    data() {
        return {
            chart: null,
            chartData: {
                labels: ['0:00', '1:00', '2:00',
                    '3:00', '4:00', '5:00',
                    '6:00', '7:00', '8:00',
                    '9:00', '10:00', '11:00',
                    '12:00', '13:00', '14:00',
                    '15:00', '16:00', '17:00',
                    '18:00', '19:00', '20:00',
                    '21:00', '22:00', '23:00'
                ],
            },
            menuFrom: false,
            actionLoading: {
                getWeeklySentOrders: false,
                generateReport: false
            },
            date: [`${format(new Date(startOfWeek(new Date, {weekStartsOn: 1})), 'YYYY-MM-DD')}`, `${format(new Date(endOfWeek(new Date, {weekStartsOn: 1})), 'YYYY-MM-DD')}`]
        }
    },
    computed: {
        dateRangeText() {
            return this.date.join(' ~ ')
        },
        savedFilters() {
            return this.$store.state.reportsAndAnalysis.orders.sentOrders.weeklySentOrdersFilters
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if ( filters[item] !== null && typeof filters[item] !== 'undefined') {
                    if (item == 'date__gte') {
                        filters['date__lte'] = this.date[1]
                        filters['date__gte'] = this.date[0]
                    }
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        }
    },
    mounted() {
        this.setDiagram()
        this.getWeeklySentOrders()
    },
    destroyed() {
        this.chart.destroy()
    },
    methods: {
        setRange(date) {
            const start = startOfWeek(date, {weekStartsOn: 1})
            const end = endOfWeek(date, {weekStartsOn: 1})

            this.date = [`${format(new Date(start), 'YYYY-MM-DD')}`, `${format(new Date(end), 'YYYY-MM-DD')}`]
            this.menuFrom = false
            this.changeFilter()
        },
        async getWeeklySentOrders() {
            this.actionLoading.getWeeklySentOrders = true

            return await this.$store.dispatch('reportsAndAnalysis/orders/getWeeklySentOrders', {
                query: this.filterQuery
            })
                .then(response => {
                    this.setChartData(response.data.results)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.getWeeklySentOrders = false
                })
        },
        getMonthDays() {
            const selectedMonth = new Date(this.filters['date__gte'])

            return getDaysInMonth(selectedMonth)
        },
        setMonthName() {
            if (this.filters.date__gte) {
                return new Date(this.filters.date__gte).toLocaleString('pl', { month: 'long', year: 'numeric'})
            }
        },
        setDiagram() {
            Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip, ChartDataLabels, Legend)

            const chartContainer = this.$refs.chartContainer

            const baseHorizontalLine = {
                id: 'baseHorizontalLine',
                beforeDatasetsDraw(chartContainer) {
                    const {ctx, chartArea: { left, width}, scales: {y} } = chartContainer

                    //line
                    ctx.strokeStyle = 'green'
                    ctx.strokeRect(left, y.getPixelForValue(50), width, 1)

                    //text
                    ctx.fillStyle = 'green'
                    ctx.textAlign = 'left'
                    ctx.fillText('Linia bazowa', left, y.getPixelForValue(51))
                    ctx.restore()
                }
            }

            this.chart = new Chart(chartContainer, {
                type: 'bar',
                plugins: [ChartDataLabels, baseHorizontalLine],
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 20
                        }
                    },
                    scales: {
                        y: {
                            suggestedMax: 80,
                            beginAtZero: true,
                            ticks: {
                                stepSize: 10
                            },
                        },
                    },
                    plugins: {
                        datalabels: {
                            display(context) {
                                return (
                                    context.dataset.data[context.dataIndex] > 0
                                )
                            },
                            anchor: 'end',
                            align: 'end',
                            offset: 4,
                            font: {
                                weight: 'bold',
                                size: 14
                            }
                        },
                        legend: {
                            position: 'bottom',
                            labels : {
                                padding: 40,
                                font: {
                                    size: 16
                                }
                            }

                        }
                    }
                },
                data: {
                    labels: this.chartData.labels,
                    datasets: [{
                        label: 'Średnia ilość zamówień',
                        data: this.chartData.data,
                        backgroundColor: '#2196F3',
                        borderWidth: 0,
                        borderRadius: 5,
                    }]
                }
            })
        },
        setChartData(ordersByHour) {
            this.chartData.data = [...new Array(24)].map((item, index) => {
                const hour = ordersByHour.find(item => item.hour === index)

                return typeof hour !== 'undefined' ? hour.average : 0
            })
            this.chart.data.datasets[0].data = this.chartData.data
            if (this.$refs.chartContainer) this.chart.update()
        },
        changeFilter() {
            this.$store.dispatch('reportsAndAnalysis/orders/setWeeklySentOrdersFilters', this.filters)
            this.getWeeklySentOrders()
        },
        generateReport() {
            this.actionLoading.generateReport = true

            html2canvas(this.$refs.chartContainer)
                .then(canvas => {
                    const imgData = canvas.toDataURL('image/png'),
                        doc = new jsPDF({
                            orientation: 'landscape'
                        })

                    doc.setFont('Roboto-Light')
                    doc.text(`Średnia nadań w godzinach na wybrany tydzień: ${format(new Date(this.date[0]), 'DD.MM.YYYY')} - ${format(new Date(this.date[1]), 'DD.MM.YYYY')}`, 10, 10)
                    doc.addImage(imgData, 'PNG', 10, 40, 275, 130)
                    doc.setFontSize(10)
                    doc.text(`Wygenerowano: ${this.formatDate(new Date())}`, 10, 200)

                    window.open(doc.output('bloburl'), '_blank')
                    this.actionLoading.generateReport = false
                })
                .catch(() => {
                    this.actionLoading.generateReport = false
                })
        },
        close() {
            this.$router.push({ name: 'reportingAndAnalysisOrdersOrders' })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>
